module.exports = __webpack_public_path__ + "media/theme/tutorial__reco--1--redeem-fc327913.png";